export default __webpack_public_path__ + "static/media/2G.9f1043d9.png";